import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SvgIconModule } from '../../components/svg-icon/svg-icon.module';
import { WidgetHomesResolver } from './widget-homes.resolver';
import { WidgetRoomsResolver } from './widget-rooms.resolver';
import { WidgetHomesPage } from './widget-homes/widget-homes.page.component';
import { WidgetRoomsPage } from './widget-rooms/widget-rooms.page.component';
import { WidgetRouting } from './widget.page.routing';
import {PipesModule} from "../../pipes/pipes.module";
import {WidgetCOHOPreviewsResolver} from "./widget-coho-previews/widget-coho-previews.resolver";
import {WidgetCOHOPreviewsPage} from "./widget-coho-previews/widget-coho-previews.page";
import {HomeLandingPreviewCardModule} from "../../components/home-landing-preview-card/home-landing-preview-card.module";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SvgIconModule,
        WidgetRouting,
        PipesModule,
        HomeLandingPreviewCardModule
    ],
    providers: [
        WidgetHomesResolver,
        WidgetRoomsResolver,
        WidgetCOHOPreviewsResolver
    ],
    declarations: [
        WidgetHomesPage,
        WidgetRoomsPage,
        WidgetCOHOPreviewsPage
    ]
})
export class WidgetPageModule {
}
